import type { WriteOp } from "../components/WriteOpsHint";

// Operations on the caller's own identity surface that this UI does not offer.
// Consent grant/revoke moved into the Pack Consents panel above.
export const ME_WRITE_OPS: WriteOp[] = [
  {
    channel: "CLI",
    label: "Eigenen SSH-Key registrieren (I2)",
    snippet: "kontextwerk-cli user register-key --public-key ~/.ssh/id_ed25519.pub",
  },
  {
    channel: "HTTP",
    label: "Eigenen SSH-Key widerrufen",
    snippet:
      'curl -X DELETE -H "Authorization: Bearer $KW_TOKEN" \\\n  http://kontextwerk.localhost:8080/core/v1/me/keys/<fingerprint>',
  },
  {
    channel: "CLI",
    label: "Bearer-Token ausstellen (operator-gated, kw:platform-admin)",
    snippet:
      "kontextwerk-cli admin bearer rotate <subject> --scope kw:ingest --realm-pin <realm>",
  },
];
